import request from '@utils/request'

export function fetchInstruments(params) {
  return request({
    url: `/admin/finance/instrument`,
    params,
  })
}

export function fetchInstrument(seq) {
  return request({
    url: `/admin/finance/instrument/${seq || 0}`,
    method: 'get',
  })
}

export function createInstrument(data) {
  return request.post('/admin/finance/instrument', data)
}

export function updateInstrument(data) {
  return request.put(`/admin/finance/instrument/${data.seq}`, data)
}

export function deleteInstrument(seq) {
  return request.delete(`/admin/finance/instrument/${seq}`)
}

export function fetchInstrumentDivearns(instrument_seq) {
  return request({
    url: `/admin/finance/instrument/${instrument_seq || 0}/divearn`,
  })
}

export function fetchInstrumentDivearn(instrument_seq, seq) {
  return request({
    url: `/admin/finance/instrument/${instrument_seq || 0}/divearn/${seq || 0}`,
    method: 'get',
  })
}

export function createInstrumentDivearn({ instrument_seq, ...data }) {
  return request.post(
    `/admin/finance/instrument/${instrument_seq || 0}/divearn/`,
    data
  )
}

export function deleteInstrumentDivearn(instrument_seq, seq) {
  return request.delete(
    `/admin/finance/instrument/${instrument_seq || 0}/divearn/${seq}`
  )
}

export function fetchFundList(params) {
  return request({
    url: '/admin/finance/fund',
    method: 'get',
    params,
  })
}

export function fetchReturnList(params) {
  return request({
    url: '/admin/finance/return',
    method: 'get',
    params,
  })
}

export function fetchDividenList(params) {
  return request({
    url: '/admin/finance/dividend',
    method: 'get',
    params,
  })
}
